import { Injectable } from '@angular/core';

declare var gapi: any;

@Injectable({ providedIn: 'root' })
export class GoogleAuthService {
  private clientId = 'AIzaSyAEwfQAhTVBE9T6dzNtHRi11GDKLVUMuWw.apps.googleusercontent.com';
  private scope = 'https://www.googleapis.com/auth/gmail.readonly https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/userinfo.email';
  private authInstance: any;

  initClient(): Promise<void> {
    return new Promise((resolve, reject) => {
      gapi.load('client:auth2', () => {
        gapi.client.init({
          clientId: this.clientId,
          scope: this.scope,
        }).then(() => {
          this.authInstance = gapi.auth2.getAuthInstance();
          resolve();
        }, reject);
      });
    });
  }

  signIn(): Promise<any> {
    return this.authInstance.signIn();
  }

  signOut(): Promise<any> {
    return this.authInstance.signOut();
  }

  getCurrentUser(): any {
    return this.authInstance.currentUser.get();
  }
}